import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RESONANCE_STRUCTURE } from '../constants';

const useResonanceStructureOptions = () => {
  const { t } = useTranslation('projects');

  return useMemo(
    () => [
      {
        label: t('respondents'),
        value: RESONANCE_STRUCTURE.RESPONDENTS,
      },
      {
        label: t('messages'),
        value: RESONANCE_STRUCTURE.MESSAGES,
      },
    ],
    [t],
  );
};

export default useResonanceStructureOptions;
